import { FormTypeVersionGeneratedEntity } from "./generated/FormTypeVersionGeneratedEntity";

export abstract class FormTypeVersionEntity extends FormTypeVersionGeneratedEntity {
    // Comment to preserve new line
}
